import { defineMessages } from 'react-intl-next';

const _default_1: {
    dismiss: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    done: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    next: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    onboardingStep1Description: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    onboardingStep1DescriptionAppify: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    onboardingStep1Heading: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    onboardingStep1Progress: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    onboardingStep2Description: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    onboardingStep2DescriptionAppify: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    onboardingStep2Heading: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    onboardingStep2Progress: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
    dismiss: {
        id: 'dynamic-cards-search-page.rovo-onboarding-dismiss',
        defaultMessage: 'Dismiss',
        description: 'Action button for dismissing rovo onboarding spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
    next: {
        id: 'dynamic-cards-search-page.rovo-onboarding-next',
        defaultMessage: 'Next',
        description: 'Action button for proceeding with rovo onboarding spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
    done: {
        id: 'dynamic-cards-search-page.rovo-onboarding-done',
        defaultMessage: 'Done',
        description: 'Action button for completing rovo onboarding spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
    onboardingStep1Heading: {
        id: 'dynamic-cards-search-page.rovo-onboarding-step-1-heading',
        defaultMessage: 'Search across all your company workspaces',
        description: 'Onboarding step 1 heading of the  spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
    onboardingStep1Description: {
        id: 'dynamic-cards-search-page.rovo-onboarding-step-1-description',
        defaultMessage: 'Filter by product to get more relevant search results.',
        description: 'Onboarding step 1 description of the  spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
    onboardingStep1Progress: {
        id: 'dynamic-cards-search-page.rovo-onboarding-step-1-progress',
        defaultMessage: '1/2',
        description: 'Onboarding step 1 progress of the  spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
    onboardingStep2Heading: {
        id: 'dynamic-cards-search-page.rovo-onboarding-step-2-heading',
        defaultMessage: "Find exactly what you're looking for",
        description: 'Onboarding step 2 heading of the  spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
    onboardingStep2Description: {
        id: 'dynamic-cards-search-page.rovo-onboarding-step-2-description',
        defaultMessage: "Depending on the product you're filtering by, these options change to help you get specific results.",
        description: 'Onboarding step 2 description of the  spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
    onboardingStep2Progress: {
        id: 'dynamic-cards-search-page.rovo-onboarding-step-2-progress',
        defaultMessage: '2/2',
        description: 'Onboarding step 2 progress of the  spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
    onboardingStep1DescriptionAppify: {
        id: 'dynamic-cards-search-page.rovo-onboarding-step-1-description-appify',
        defaultMessage: 'Filter by app to get more relevant search results.',
        description: 'Onboarding step 1 description of the  spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
    onboardingStep2DescriptionAppify: {
        id: 'dynamic-cards-search-page.rovo-onboarding-step-2-description-appify',
        defaultMessage: "Depending on the app you're filtering by, these options change to help you get specific results.",
        description: 'Onboarding step 2 description of the  spotlight wizard. Pops up when user has clicked the Build Dynamic Cards and the search page showing.',
    },
});
export default _default_1;
